import { ErrorData } from "packages/errors/errors";
import { put } from "packages/rest/api";

export async function ResendEmailVerificationAPI():Promise<ErrorData | null> {
    const res = await put({url: "session/emails/verifications"});
    return res[1];
}
